import React from 'react';
import { EmailBadge, RetryButton, ContactLinks, isMissed, missedBorder, fmtDate } from './Shared';

export const QuoteCard = ({ q, onRetry, busy }) => (
  <div className={`bg-white border rounded-sm p-5 ${missedBorder(q.email_status)}`} data-testid={`admin-quote-${q.id}`}>
    <div className="flex flex-wrap items-start justify-between gap-3 mb-2">
      <div>
        <div className="font-display uppercase font-bold text-lg text-neutral-950">{q.name}</div>
        <div className="text-xs text-neutral-500">{fmtDate(q.createdAt)} • {q.service}</div>
      </div>
      <div className="flex items-center gap-3">
        <EmailBadge status={q.email_status} />
        {isMissed(q) && <RetryButton onClick={() => onRetry(q.id)} busy={busy} testId={`retry-quote-${q.id}`} />}
      </div>
    </div>
    <ContactLinks phone={q.phone} email={q.email} />
    {q.message && <p className="text-sm text-neutral-700 mt-3 whitespace-pre-line">{q.message}</p>}
    <div className="flex flex-wrap gap-3 mt-3 text-xs">
      {q.requestCallback && <span className="font-semibold text-red-600">Requested a call back</span>}
      {(q.files || []).map((f, i) => (
        <a key={f} href={`${process.env.REACT_APP_BACKEND_URL}${f}`} target="_blank" rel="noopener noreferrer" className="underline text-neutral-700 hover:text-red-600" data-testid={`admin-quote-photo-${i}`}>Photo {i + 1}</a>
      ))}
    </div>
  </div>
);
